<template>
  <div id="app">
    <template v-if="$route.path === '/exhibition'">
      <newHeader></newHeader>
      <div id="container">
      <router-view />
    </div>
    <ExhibitionFooter></ExhibitionFooter>
    <GoTop></GoTop> 
    </template>
    <template v-else>
      <newHeader></newHeader>
    <div id="container">
      <router-view />
    </div>
    <Footer></Footer>
    <!-- <GoTop></GoTop> -->
    </template>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style scoped>
#container {
  /* min-height: 100vh; */
  /* overflow-x: hidden; */
}
</style>
<style>
.none{
display:none !important;
}
</style>


// WEBPACK FOOTER //
// src/App.vue